import { types } from 'mobx-state-tree'

export const AdobeTimelineEvent = types.model('AdobeTimelineEvent', {
  label: types.string,
  start: types.number,
  end: types.number,
  fps: types.integer,
})

